import React from 'react';
import T from 'prop-types';

const SectionSummary = ({ title, description, caption, children, srOnlyDescription }) => (
  <header className="section-summary">
    <div
      className="section-summary__left"
      aria-labelledby="section-title"
      aria-describedby={srOnlyDescription ? 'section-desc' : undefined}
    >
      <h3 className="section-summary__title h3" id="section-title">
        {title}
      </h3>
      {srOnlyDescription && (
        <p id="section-desc" className="visually-hidden">
          {srOnlyDescription}
        </p>
      )}
      {description && <p className="section-summary__description">{description}</p>}
      {caption && <p className="section-summary__caption">{caption}</p>}
    </div>
    <div className="section-summary__content">{children}</div>
  </header>
);

SectionSummary.propTypes = {
  title: T.string.isRequired,
  description: T.string,
  caption: T.string,
  children: T.node,
  srOnlyDescription: T.string,
};

export default SectionSummary;
